export const GET_ACTIVITY_START = 'GET_ACTIVITY_START';
export const GET_ACTIVITY_END = 'GET_ACTIVITY_END';
export const GET_ACTIVITY_SUCCESS = 'GET_ACTIVITY_SUCCESS';
export const GET_ACTIVITY_FAILURE = 'GET_ACTIVITY_FAILURE';
export const GET_ACTIVITIES = 'GET_ACTIVITIES';
